export function roundTo10(n: number): number {
  return Math.ceil(n / 10) * 10;
}
